// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__+hTg+","brandContainer":"Header_brandContainer__GUN32"};